import { render, staticRenderFns } from "./ProductDetailsPage.vue?vue&type=template&id=2dc3409b&scoped=true&"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsPage.vue?vue&type=style&index=0&id=2dc3409b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc3409b",
  null
  
)

export default component.exports